import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import wordClient from '../../client/WordClient';
import { Pagination, Spin, Row } from 'antd';
import WordInfoCard from "../WordInfoCard/WordInfoCard";
import usePagedList from '../../hooks/usePagedList';
import useIsMobile from '../../hooks/useIsMobile';

// Модульная функция: стабильная ссылка для эффекта загрузки в usePagedList
const fetchWordsPage = (deckId, pageIndex, pageSize) =>
    wordClient.getWordsByDeckId(deckId, pageIndex, pageSize);

const WordList = () => {
    const { t } = useTranslation();
    const {
        selectedDeck, items: words, loading, total, currentPage, pageSize, setPage, updateItem,
    } = usePagedList(fetchWordsPage, t('list.loadWordsFailed'));
    const isMobile = useIsMobile();

    if (!selectedDeck) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <p>{t('list.selectDeckForWords')}</p>
            </div>
        );
    }

    return (
        <div style={{ width: '100%', padding: '0px' }}>
            {loading ? (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin tip={t('list.loadingWords')} size="large" />
                </div>
            ) : (
                <>
                    {words && words.length > 0 ? (
                        words.map((word) => (
                            <WordInfoCard
                                key={word.id}
                                word={word}
                                locale={selectedDeck.locale}
                                onUpdateWord={updateItem}
                            />
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '50px' }}>
                            <p>{t('list.noWords')}</p>
                        </div>
                    )}
                    {total > pageSize && (
                        <Row justify="center" style={{ marginTop: '20px' }}>
                            <Pagination
                                current={currentPage}
                                pageSize={pageSize}
                                total={total}
                                onChange={setPage}
                                simple={isMobile}
                                size={isMobile ? 'small' : 'default'}
                            />
                        </Row>
                    )}
                </>
            )}
        </div>
    );
};

export default WordList;
